'use client';
import Link from 'next/link';
import styled, { css } from 'styled-components';

export const StyledSummaryCard = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const SummaryInfo = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
`;

export const AvatarContainer = styled.div`
  flex: 1 0 ${props => props.theme.spacing(20)};
  margin-right: ${props => props.theme.spacing(4)};
`;

export const Modify = styled.div`
  display: flex;
`;

const buttonStyle = css`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  ${props => props.theme.typography.bodyBold};
  color: ${props => props.theme.colors.hero.blueberry};
  background: none;
  border: none;
  padding: 0;
  margin-top: ${props => props.theme.spacing(1)};
  margin-right: ${props => props.theme.spacing(2)};
  justify-content: center;
`;

export const IconLink = styled(Link)`
  ${buttonStyle}
`;

export const IconButton = styled.button`
  ${buttonStyle}
`;

export const IconLinkText = styled.span`
  margin-left: ${props => props.theme.spacing(1)};
`;
